import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { API, FORM_KEY } from '../api'

const useFetch = () => {
    const { t } = useTranslation()
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const navigate = useNavigate()

    const { locale } = useParams()

    const fetchData = async (url, method = 'GET', body = null, paramsLocale) => {
        setLoading(true)
        setError(null)
        
        try {
            let options = { method: method }

            if (method === 'POST')
                options = {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                        // ...headers
                    },
                    body: JSON.stringify(body),
                }

            const response = await fetch(url, options)

            if (!response.ok) {
                throw new Error(t('errors.try_again'))
            }

            const responseData = await response.json()
            setData(responseData)

            if (responseData.status === 'error') {
                throw new Error(t('errors.try_again'))
            }

            if (responseData.form_key) {
                if (responseData.form_key === 'krd_negative_verification' || responseData.form_key === 'krd_reject')
                    navigate(`/${locale || 'pl'}/krd_negative_verification`)
            }

            if (responseData.status === 'success' && responseData.id) {
                navigate(`/${paramsLocale || 'pl'}/RAC/step2/${responseData.id}`)
            } else if (responseData.form_key && responseData.variables.pid) {
                responseData.form_key === 'date_locations_selection' &&
                    navigate(`/${locale || 'pl'}/RAC/step1/${responseData.variables.pid}`)

                responseData.form_key === 'offer_presentation' &&
                    navigate(`/${locale || 'pl'}/RAC/step2/${responseData.variables.pid}`)

                responseData.form_key === 'packages_equipment_selection' &&
                    navigate(`/${locale || 'pl'}/RAC/step3/${responseData.variables.pid}`)

                responseData.form_key === 'client_data_invoice_krd' &&
                    navigate(`/${locale || 'pl'}/RAC/step4/${responseData.variables.pid}`)

                responseData.form_key === 'summary_payment' &&
                    navigate(`/${locale || 'pl'}/RAC/step5/${responseData.variables.pid}`)

                responseData.form_key === 'reservation_summary' &&
                    navigate(`/${locale || 'pl'}/RAC/summary/${responseData.variables.pid}`)
            }
        } catch (error) {
            setError(t('errors.try_again'))
        } finally {
            setLoading(false)
        }
    }

    return { data, loading, error, fetchData }
}

export default useFetch
